import React from 'react';
import PropTypes from 'prop-types';

import {
    Table
} from 'reactstrap';

import TableMovementItem from './TableMovementItem';
import Header from './TableHeader';
import TableTotal from './TableTotal';

export default function TableReport({ data, totals, tipo, setColumnOrder, columnOrder }) {

    return (
        <div className="table-responsive" style={{position: 'relative', maxHeight: '500px'}}>
            <Table className="table mb-0 report-table table-bordered table-sm">
                <thead className='table-light'>
                    <Header tipo={ tipo } setColumnOrder={ setColumnOrder } columnOrder={columnOrder}/>
                </thead>
                <tbody>
                    
                    { data.map(item => (
                        <TableMovementItem key={ item.id } item={ item }/>
                    )) }
                </tbody>
                <tfoot className='table-light'>
                    <TableTotal totals={ totals }/>
                </tfoot>
            </Table>
        </div>
    );
}

TableReport.propTypes = {
    data: PropTypes.any,
    totals: PropTypes.object,
    tipo: PropTypes.string,
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object
};